import { ReactComponent as Dark } from './Dark.svg';
import { ReactComponent as Secondary } from './Secondary.svg';
import { ReactComponent as White } from './White.svg';

export default { Dark, Secondary, White }
